/**
 * The web half of every sector module. One entry per module, matching the
 * core half's `code`.
 */
import { associationUi } from './association';
import { hospitaliteUi } from './hospitalite';
import type { SectorModuleUi } from './types';

export const MODULE_UIS = [associationUi, hospitaliteUi] as const satisfies readonly SectorModuleUi[];

/**
 * The registry widened for iteration — the narrow tuple's element is `never`
 * while no module is registered. Every registry that folds reads it here.
 */
export const REGISTERED_MODULE_UIS: readonly SectorModuleUi[] = MODULE_UIS;

export type { NavContribution, SectorModuleUi } from './types';
export { contributedNavKeys, ownGroups } from './types';
